import {Component, inject} from '@angular/core';
import {RefModelSidebarService} from '@q9elements/ui-kit/refmodels';

@Component({
  selector: 'q9rme-system-info-tab',
  templateUrl: './system-info-tab.component.html',
  styleUrls: ['./system-info-tab.component.scss']
})
export class SystemInfoTabComponent {
  protected refModelSidebarService = inject(RefModelSidebarService);

  public get refModelNode() {
    return this.refModelSidebarService?.refModelNode();
  }
}
